(function (root) {
  'use strict';
  if (root.SolsticeCompositionContact) return;
  const key = 'solstice_composition_contact_v1';
  const normalize = value => typeof value === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()) ? value.trim().toLowerCase() : '';
  let memory = '';
  const getEmail = () => {
    try {
      const saved = JSON.parse(root.localStorage.getItem(key));
      return normalize(saved?.email) || memory;
    } catch (_) { return memory; }
  };
  root.addEventListener('klaviyoForms', event => {
    const detail = event.detail;
    if (!['submit', 'stepSubmit'].includes(detail?.type)) return;
    const email = normalize(detail.metaData?.email || detail.metaData?.$email);
    if (!email) return;
    memory = email;
    try { root.localStorage.setItem(key, JSON.stringify({ email })); } catch (_) {}
  });
  root.SolsticeCompositionContact = { getEmail };
})(window);
